<div class="form-check mb-2" [class.has-error]="showError">
  <ng-template #fieldComponent></ng-template>
  <label class="form-check-label" [for]="id" [ngClass]="props.labelClass">
    <ish-shipping-info [shippingMethodId]="props.value" />
    <button
      *ngIf="props.description"
      type="button"
      class="btn btn-link details-tooltip"
      [ngbPopover]="ShippingMethodDescription"
      placement="top"
    >
      {{ 'checkout.detail.text' | translate }}
      <fa-icon [icon]="['fas', 'info-circle']" />
    </button>
  </label>
</div>

<ng-template #ShippingMethodDescription>
  <span [innerHTML]="props.description"></span>
</ng-template>
